export default {
  common: {
    appName: 'Honey Badger Entertainment',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    submit: 'Senden',
    save: 'Speichern',
    usernameRequired: 'Bitte Benutzernamen eingeben!',
    passwordRequired: 'Bitte Passwort eingeben!',
    viewMore: 'Mehr anzeigen',
    refreshSuccess: 'Aktualisiert',
    noMore: 'Keine weiteren Daten',
    emptyData: 'Keine Daten vorhanden',
  },
  footer: { home: 'Startseite', lottery: 'Lotterie', game: 'Reservierung', video: 'Video', mine: 'Profil' },
  lang: { title: 'Sprache / Language', current: 'Aktuelle Sprache' },
  home: {
    recommendedTasks: 'Empfohlene Aufgaben',
    popularRanking: 'Beliebtheitsranking',
    hotRecommend: 'Top-Empfehlungen',
    playCount: 'Aufrufe: {count}',
    noticeLoading: 'Wird geladen...',
  },
  game: {
    hallTitle: 'Reservierungshalle',
    categoryAll: 'Alle',
  },
  choose: {
    title: 'Begleitung',
    tabCities: 'Städteverzeichnis',
    tabProcess: 'Ablauf & Preise',
    privacyNotice: 'Die authentischsten Begleitdamen, Business-Escorts und lokalen Dates im ganzen Netz. Zum Schutz der Privatsphäre jedes Nutzers ist die Mitgliedschaft nur über unsere Rezeption oder eine Empfehlung eines erfahrenen Mitglieds möglich.',
    resourcesQ: 'Welche Auswahl gibt es?',
    resourcesA: 'Influencerinnen, Models, Flugbegleiterinnen, junge Models und Studentinnen — was Sie sich vorstellen können, wir organisieren es.',
    scopeQ: 'Einsatzbereich?',
    scopeA: 'Kostenlose Treffen vor Ort, Anreise an jeden Ort im ganzen Land. In allen Großstädten vertreten; kleinere Städte auf Anfrage über unsere Rezeption.',
    book: 'Reservierung',
    contactConcierge: 'Bitte kontaktieren Sie einen Berater oder Rezeptionisten',
    cityNames: {
      beijing: 'Peking',
      shanghai: 'Schanghai',
      guangzhou: 'Guangzhou',
      shenzhen: 'Shenzhen',
      nanjing: 'Nanjing',
      changsha: 'Changsha',
      chongqing: 'Chongqing',
      xian: 'Xi\'an',
    },
  },
  lottery: {
    gameRecord: 'Aufgabenverlauf',
    orderList: 'Auftragsblatt',
    orderItemDetail: '1 Einsatz X {money} = {money}',
    clearOrder: 'Blatt leeren',
    confirmSubmit: 'Bestätigen und senden',
    availableBalance: 'Verfügbares Guthaben',
    yuan: 'Yuan',
    currentPick: 'Aktuelle Auswahl: ',
    amountPerBet: 'Betrag pro Einsatz: ',
    amountPlaceholder: 'Betrag eingeben',
    amountInvalid: 'Ungültiger Betrag!',
    fillAmount: 'Bitte Betrag eingeben!',
    selectNumberFirst: 'Bitte Zahlen auswählen!',
    insufficientBalance: 'Guthaben zu niedrig, bitte Kundenservice kontaktieren!',
    notSelected: 'Nicht ausgewählt',
    contactAdminForTask: 'Bitte den Administrator kontaktieren, um diese Aufgabe freizuschalten!',
    drawSuccess: 'Ziehung abgeschlossen, Runde: {expect}',
    periodNumber: 'Runde',
    betUnit: 'Wetten',
    totalAmountLabel: 'Gesamtbetrag: ',
    totalCountLabel: 'Anzahl der Wetten: ',
    drawResult: 'Ziehzahlen',
    big: 'Groß',
    small: 'Klein',
    single: 'Ungerade',
    doubleNum: 'Gerade',
    rules: {
      title: 'Spielregeln',
      tipTitle: 'Spielhinweis',
      tipDetail: 'Wählen Sie Ihre Zahlen aus den verfügbaren Summenformen, um eine Wette zu platzieren.',
      winTitle: 'Gewinnbedingungen',
      winDetail: 'Eine Summe von 11~18 über die drei gezogenen Zahlen ist Groß; eine Summe von 3~10 ist Klein.',
      exampleTitle: 'Wettbeispiel',
      exampleDetail: 'Wette: Klein. Gezogene Zahlen: 123 — Ergebnis: Klein.',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: 'Aufladen', withdraw: 'Auszahlung', game: 'Wette' },
    },
    withdraw: {
      amountLabel: 'Auszahlungsbetrag (CNY)',
      all: 'Alle',
      limitRule1: '1. Einzelgrenze: mindestens {min}, höchstens {max}',
      limitRule2: '2. Auszahlungen: höchstens {num} Auszahlungen pro Tag',
      limitRule3: '3. Gutschrift: in der Regel etwa 5 Minuten, schnellste Gutschrift innerhalb von 2 Minuten',
      limitTitle: 'Limit-Hinweis',
      balanceLabel: 'Guthaben: ',
      submit: 'Jetzt auszahlen',
      amountInvalid: 'Bitte geben Sie einen gültigen Betrag ein',
    },
    bindCard: {
      formLabel: 'Bitte geben Sie Ihre Auszahlungskarte an',
      bankidLabel: 'Kartennummer',
      bankidPlaceholder: 'Geben Sie die echte Kartennummer ein',
      bankLabel: 'Bankname',
      bankPlaceholder: 'Bank auswählen',
      notice: 'Sehr geehrter Kunde, zu Ihrer Sicherheit hinterlegen Sie bitte Ihren echten Namen und legen Sie ein Auszahlungspasswort fest. Stimmt der Name nicht mit dem Kontoinhaber überein, ist keine Auszahlung möglich.',
      submit: 'Bindung bestätigen',
      bankidRequired: 'Bitte geben Sie die Kartennummer ein!',
      bankRequired: 'Bitte wählen Sie eine Bank aus!',
    },
    setbank: {
      title: 'Auszahlungskarte',
      addCard: 'Auszahlungskarte hinzufügen',
      tips: 'Hinweis: Bitte binden Sie eine große Geschäftsbank an. Wenden Sie sich an den Live-Kundendienst, wenn Sie etwas ändern möchten.',
      setNameFirst: 'Bitte legen Sie zuerst Ihren Namen fest, bevor Sie eine Bankkarte binden!',
      setPayPasswordFirst: 'Bitte legen Sie zuerst ein Auszahlungspasswort fest, bevor Sie eine Bankkarte binden!',
    },
    setPayPassword: {
      firstPrompt: 'Auszahlungspasswort eingeben',
      secondPrompt: 'Auszahlungspasswort erneut eingeben',
      incomplete: 'Bitte vollständig ausfüllen',
      mismatch: 'Die beiden Passwörter stimmen nicht überein!',
    },
    setLoginPassword: {
      oldPassword: 'Altes Passwort',
      oldPasswordPlaceholder: 'Geben Sie Ihr altes Passwort ein',
      newPassword: 'Neues Passwort',
      newPasswordPlaceholder: 'Geben Sie Ihr neues Passwort ein',
      confirmPasswordPlaceholder: 'Geben Sie Ihr neues Passwort erneut ein',
      incomplete: 'Bitte vollständig ausfüllen!',
      mismatch: 'Die beiden Passwörter stimmen nicht überein',
    },
    setname: {
      nameLabel: 'Name',
      namePlaceholder: 'Geben Sie Ihren echten Namen ein',
      notice: 'Zu Ihrer Kontosicherheit muss der echte Name mit dem Namen der gebundenen Bankkarte übereinstimmen',
      alreadySet: 'Bitte nicht mehrfach festlegen!',
      nameRequired: 'Bitte geben Sie Ihren Namen ein!',
    },
    setsex: {
      male: 'Männlich',
      female: 'Weiblich',
    },
    infomation: {
      avatar: 'Profilbild',
      chooseAvatar: 'Profilbild auswählen',
      realName: 'Echter Name',
      notSet: 'Nicht festgelegt',
      gender: 'Geschlecht',
      unknown: 'Unbekannt',
      bindInfo: 'Bindungsinformationen',
      bound: 'Gebunden',
      none: 'Keine',
    },
    index: {
      recharge: 'Aufladen',
      withdraw: 'Auszahlen',
      myWallet: 'Meine Wallet',
      details: 'Details',
      balanceLabel: 'Guthaben: ',
      personalReport: 'Persönlicher Bericht',
      accountDetail: 'Kontodetails',
      profileCenter: 'Profilzentrum',
      notice: 'Ankündigungen',
      customerService: 'Kundenservice',
      completeTaskFirst: 'Bitte schließen Sie zuerst die Registrierung ab',
      contactServiceToRecharge: 'Bitte kontaktieren Sie den Kundenservice zum Aufladen',
      setPayoutCardFirst: 'Bitte richten Sie zuerst eine Auszahlungskarte ein',
      featureDisabled: 'Diese Funktion ist noch nicht verfügbar',
      accountOffline: 'Konto offline',
      loginRegister: 'Anmelden/Registrieren',
      loginHint: 'Zum Anzeigen anmelden',
    },
    setting: {
      basicInfo: 'Grundinformationen',
      loginPassword: 'Anmeldepasswort',
      payPassword: 'Zahlungspasswort',
      payPasswordAlreadySet: 'Zahlungspasswort ist bereits eingerichtet!',
      signOut: 'Abmelden',
    },
    gameRecord: {
      betAmount: 'Wetteinsatz: {money}',
      betTime: 'Wettzeit: {time}',
      settleTime: 'Abrechnungszeit: {time}',
    },
    withdrawRecord: {
      amount: 'Auszahlungsbetrag: {money}',
      desc: 'Auszahlungshinweis: {desc}',
      submitTime: 'Antragszeit: {time}',
      reviewTime: 'Prüfzeit: {time}',
    },
    report: {
      profitLabel: 'Gewinn/Verlust',
      formulaTip: 'Gewinn = Gewinnsumme - Einsatz + Einzahlungen - Auszahlungen',
      playAmount: 'Einsatz',
      rechargeAmount: 'Einzahlung',
      withdrawAmount: 'Auszahlung',
      winAmount: 'Gewinnsumme',
    },
    service: {
      contact: 'Jetzt beraten',
      slogan: 'Bei Fragen können Sie uns jederzeit kontaktieren',
    },
  },
  video: {
    hallTitle: 'Video-Kino',
    hotRecommend: 'Top-Empfehlungen',
    playCount: 'Aufrufe: {count}',
    playCountSuffix: '{count} Aufrufe',
    rechargeToWatch: 'Bitte laden Sie zuerst Guthaben auf, um Videos anzusehen!',
  },
  recharge: {
    title: 'Aufladen',
    chooseCoin: 'Währung wählen',
    address: 'Einzahlungsadresse',
    copy: 'Adresse kopieren',
    copied: 'Kopiert',
    amount: 'Einzahlungsbetrag',
    uploadShot: 'Überweisungsscreenshot hochladen',
    submit: 'Einzahlungsantrag einreichen',
    pending: 'In Prüfung',
    done: 'Gutschrift erfolgt',
    rejected: 'Abgelehnt',
  },
  payMethod: {
    title: 'Zahlungsmethode wählen',
    bankCard: 'Bankkarte',
    wallet: 'Krypto-Wallet',
    unbind: 'Trennen',
    bindNew: 'Neue Adresse verknüpfen',
    confirmUnbind: 'Diese Zahlungsmethode wirklich trennen?',
    payPassword: 'Auszahlungspasswort',
    wrongPassword: 'Falsches Auszahlungspasswort',
    chooseFirst: 'Bitte zuerst eine Zahlungsmethode wählen',
  },
  router: {
    Index: { title: 'Startseite' },
    Home: { title: 'Startseite' },
    Choose: { title: 'Begleitung' },
    List: { title: 'Begleitungsliste' },
    Profile: { title: 'Begleitungsprofil' },
    Mine: { title: 'Profil' },
    Video: { title: 'Video' },
    Game: { title: 'Spiele' },
    Login: { title: 'Anmelden' },
    Register: { title: 'Registrieren' },
    ServiceOnline: { title: 'Kundendienst' },
    ServicePage: { title: 'Kundendienst' },
    Setting: { title: 'Einstellungen' },
    Infomation: { title: 'Grunddaten' },
    Setname: { title: 'Echten Namen ändern' },
    Setsex: { title: 'Geschlecht ändern' },
    SetPayPassword: { title: 'Zahlungspasswort' },
    SetLoginPassword: { title: 'Login-Passwort' },
    Lottery: { title: 'Lotterie' },
    Notice: { title: 'Ankündigungen' },
    PlayVideo: { title: 'Video abspielen' },
    Setbank: { title: 'Auszahlungskarte hinzufügen' },
    BindCard: { title: 'Auszahlungskarte hinzufügen' },
    Withdraw: { title: 'Auszahlung' },
    Recharge: { title: 'Aufladen' },
    Personalreport: { title: 'Persönlicher Bericht' },
    WithdrawRecord: { title: 'Auszahlungsverlauf' },
    AccountDetail: { title: 'Kontodetails' },
    GameRecord: { title: 'Spielhistorie' },
  },
  captcha: {
    placeholder: 'Bild-Captcha',
    refresh: 'Zum Aktualisieren antippen',
    error: 'Captcha falsch',
    required: 'Bitte Captcha eingeben',
  },
  login: {
    title: 'Anmelden',
    usernamePlaceholder: 'Bitte Benutzernamen eingeben',
    passwordPlaceholder: 'Bitte Passwort eingeben',
    forgotPassword: 'Passwort vergessen?',
    noAccountRegister: 'Kein Konto? Jetzt registrieren',
    submit: 'Anmelden',
  },
  register: {
    title: 'Registrieren',
    usernamePlaceholder: 'Bitte Benutzernamen eingeben (6-12 Buchstaben oder Ziffern)',
    passwordPlaceholder: 'Bitte Login-Passwort eingeben (6-12 Buchstaben oder Ziffern)',
    codePlaceholder: 'Bitte Einladungscode eingeben',
    protocol: 'Ich habe die Bestimmungen der „Vereinbarung zur Kontoeröffnung" gelesen und stimme ihnen zu',
    submit: 'Registrieren',
    codeRequired: 'Bitte Einladungscode eingeben!',
    agreementRequired: 'Bitte unten das Kästchen zur Vereinbarung zur Kontoeröffnung anklicken!',
  },
}
